import { render, staticRenderFns } from "./TableRowAvgSellingPricePostDisc.vue?vue&type=template&id=3ea1664c&lang=pug&"
import script from "./TableRowAvgSellingPricePostDisc.vue?vue&type=script&lang=js&"
export * from "./TableRowAvgSellingPricePostDisc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ea1664c')) {
      api.createRecord('3ea1664c', component.options)
    } else {
      api.reload('3ea1664c', component.options)
    }
    module.hot.accept("./TableRowAvgSellingPricePostDisc.vue?vue&type=template&id=3ea1664c&lang=pug&", function () {
      api.rerender('3ea1664c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/audiology-kpis/benchmarks/table-rows/TableRowAvgSellingPricePostDisc.vue"
export default component.exports